
import React, { useState, Fragment, useRef, useEffect } from "react"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

import { sendOrderIsReadySms } from "services"
import { Button, ConfirmationModal } from "components"
import classes from "./OrderDetailReadySmsButton.module.scss"

const OrderDetailReadySmsButton = props => {
  const { order } = props

  const [t] = useTranslation()

  const [sending, setSending] = useState(false)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const unmount = useRef(false)

  const handleCompleteOrder = async () => {
    setSending(true)

    try {
      await sendOrderIsReadySms(order._id)

      setShowConfirmationModal(false)

      toast.success(t("پیامک_ارسال_شد"))
    } catch (err) {
      console.log(err)

      toast.error(t("پیامک_ارسال_نشد"))
    }

    setSending(false)
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <Fragment>
      <Button
        onClick={() => setShowConfirmationModal(true)}
        className={classes["button"]}
      >
        {t("ارسال_پیامک")}
      </Button>

      <ConfirmationModal
        title={t("آیا_می_خواهید_پیامک_سفارش_آماده_تحویل_را_ارسال_کنید")}
        show={showConfirmationModal}
        onConfirm={handleCompleteOrder}
        onHide={() => setShowConfirmationModal(false)}
        loading={sending}
      />
    </Fragment>
  )
}

export default OrderDetailReadySmsButton